const siteLocale = theme.cart ? theme.cart.attributes.language : 'en-CA';

LRObject.$hooks.register('startProcess',function ( ) {
  jQuery('#fade').show();
});

LRObject.$hooks.register('endProcess',function ( ) {
  jQuery('#fade').hide();
});

function setErrorMessage(msg) {
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-error-message").text(msg);
  visibleLoadingSpinner(false);
}

function setMessage(msg) {
  jQuery("#lr-raas-message").show().addClass("loginradius-raas-success-message").text(msg);
  visibleLoadingSpinner(false);
}

LRObject.$hooks.register('startProcess',function () {
  jQuery('.lr_fade').show();
});

if (siteLocale === 'fr-CA') {
  $('#lr-social-traditional-login h1').html('<span>Connexion</span> Patient');

  LRObject.$hooks.call('customizeFormPlaceholder',{
    "emailid" : "Adresse courriel",
    "password" : "Mot de passe"
  });

  LRObject.$hooks.call('setButtonsName', {
    login : "Connexion",
    registration: "S'enregistrer"
  });
} else {
  LRObject.$hooks.call('customizeFormPlaceholder',{
    "emailid" : "Email address",
    "password" : "Password"
  });

  LRObject.$hooks.call('setButtonsName', {
    login : "Login Now",
    registration: "Register"
  });
}

LRObject.$hooks.call('customizeFormLabel', {
  "emailid" : " ",
  "password" : " "
});

LRObject.$hooks.register('afterFormRender', function (name, schema) {
  $("#lr-raas-forgot-password").insertBefore("#loginradius-submit-login");
});

jQuery(window).load(function () {
  jQuery('.lr_fade').hide();
});

jQuery(".site_login_btn").click(function () {
  jQuery(".account-modal-overlay").show();

  jQuery('.content-loginradius-raas-emailid label').text('Email');

  if (!jQuery('.btn-register').length) {
    var newAccountBtn = '<a class="btn-register" style="float:left;" >New Account</a>';
    jQuery('#login-container form').append(newAccountBtn);
  }

  if (!jQuery('#register-interfacecontainer').length) {
    jQuery('#login-interfacecontainer')
    .clone(true)
    .attr('id', 'register-interfacecontainer')
    .appendTo("#social-registration-interface");
  }
});

jQuery(".account-modal-overlay .close-btn img").click(function () {
  jQuery(".account-modal-overlay").hide();
});

LRObject.util.ready(function () {
  window.lr_raas_settings = window.lr_raas_settings || {};

  if (window.lr_raas_settings.registration) {
    registration_options.container = window.lr_raas_settings.registration_containerid;

    LRObject.util.ready(function() {
      LRObject.init("registration",registration_options);
    })
  }

  if (window.lr_raas_settings.login) {
    login_options.container = window.lr_raas_settings.login_containerid;

    LRObject.util.ready(function() {
      LRObject.init("login",login_options);
    });
  }

  if (window.lr_raas_settings.forgotpassword) {
    forgotpassword_options.container = window.lr_raas_settings.forgotpassword_containerid;
    LRObject.init("forgotPassword", forgotpassword_options);
  }

  if (window.location.search.indexOf('vtoken') > -1 && window.location.search.indexOf('vtype=reset') > -1) {
    $("#lr-raas-login").hide();
    $("#login-container").hide();
    $("#lr-social-traditional-login").hide();
    $("#lr-raas-resetpassword").show();

    if (window.lr_raas_settings.resetpassword) {
      resetpassword_options.container = window.lr_raas_settings.resetpassword_containerid;

      LRObject.init("resetPassword", resetpassword_options);
    }
  }

  if (window.location.search.indexOf('vtoken') > -1 && window.location.search.indexOf('vtype=emailverification') > -1) {
    $("#registration-container").hide();
    $("#lr-raas-message").css("display", "block");
    LRObject.init("verifyEmail", verifyemail_options);
  }


  if (window.lr_raas_settings.sociallogin) {
    raasoption.hashTemplate = true;

    var custom_interface_option = {};
    custom_interface_option.templateName = 'loginradiuscustom_tmpl';
    LRObject.util.ready(function() {
      LRObject.customInterface(window.lr_raas_settings.sociallogin_interfaceid, custom_interface_option);
    });

    sl_options.container = window.lr_raas_settings.sociallogin_containerid;
    LRObject.util.ready(function() {
      LRObject.init('socialLogin', sl_options);
    });
  }

  var maxYear = new Date().getFullYear();
  var minYear = maxYear - 100;
  $('body').on('focus', ".loginradius-raas-birthdate", function() {
    $('.loginradius-raas-birthdate').datepicker({
      dateFormat: 'mm-dd-yy',
      maxDate: new Date(),
      minDate: "-100y",
      changeMonth: true,
      changeYear: true,
      yearRange: (minYear + ":" + maxYear)
    });
  });

  if (getParameterByName("vtype") && getParameterByName("vtype") == "reset" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
  }

  if (getParameterByName("vtype") && getParameterByName("vtype") == "emailverification" && getParameterByName("vtoken")) {
    jQuery(".account-modal-overlay").show();
  }
});

function hideMessage() {
  jQuery("#lr-raas-message").hide();
}

function addJs(url, context) {
  context = context || document;
  var head = context.getElementsByTagName('head')[0];
  var js = context.createElement('script');
  js.src = url;
  js.type = "text/javascript";
  head.appendChild(js);
  return js;
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
  results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function exchangeMultipassToken(lrtoken, handle, path = '/') {
  let finalPath = path;

  if (window.location.href.includes('account/login?order=')) {
    let orderId = window.location.href.slice(window.location.href.lastIndexOf('=') + 1);
    finalPath = '/account/orders/' + orderId;
  }

  finalPath = encodeURI(finalPath);

  var url = "https://cloud-api.loginradius.com/sso/shopify/api/token?store=" + lrshopifystore
  url = url + "&return_url=" + finalPath;

  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
    headers: {
      'Authorization': 'Bearer ' + lrtoken,
      'X-LoginRadius-ApiKey': raasoption.apiKey
    },
    success: handle
  });
}

// If found an active session is found, goto the callback function
var ssologin_options = {};

ssologin_options.onSuccess = function(response) {
  // On Success
  let expiry = new Date(new Date().getTime() + 2*60*60*1000);
  Cookies.set('_age_validated', true, {expires: expiry});

  let elements = {
    approve: document.querySelector('.js-age-gate-approve'),
    deny: document.querySelector('.js-age-gate-deny'),
    // submit: document.querySelector('.js-age-gate-submit'),
    modal: document.querySelector('.js-age-gate'),
    modalContainer: document.querySelector('.js-age-gate-container')
  }

  elements.modalContainer.classList.add('is-hidden');
  elements.modal.classList.remove('is-visible');
};

// AURORA - This was required to properly handle login for Shopify.
LRObject.util.ready(function () {
  LRObject.init("ssoLogin", ssologin_options);
});

//Login
var login_options = {};

login_options.onSuccess = function(response) {
  let redirectUrl = undefined;
  let cookie = (Cookies.get('_age_validated') == 'true');
  sessionStorage.removeItem('cart_id');
  sessionStorage.removeItem('vac_cart_id');
  // Check for redirect_url URL param
  if (getParameterByName('redirect_url')) {
    redirectUrl = `${getParameterByName('redirect_url')}`;
    redirectUrl = redirectUrl.split("");

    // add slash to front of path
    if(redirectUrl[0] !== '/') {
      redirectUrl.unshift('/')
    }

    redirectUrl = redirectUrl.join("");
  }

  if (!cookie && redirectUrl === undefined && window.location.pathname !== '/') {
    // User is not age validated and URL does not contain redirect_url param
    redirectUrl = window.location.pathname;
  }

  exchangeMultipassToken(response.access_token, function(data){
    window.location = data.url;
  }, redirectUrl);
}

login_options.onError = function(errors) {
  //On Errors
  var warningMsg = errors[0].Message;
  if (warningMsg.includes('field is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Ce champ est obligatoire.';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Invalid user ID and/or password') && siteLocale === 'fr-CA') {
    warningMsg = 'Identifiant ou mot de passe invalide';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Valid email ID is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Un idendifiant email valide est requis';
    setErrorMessage(warningMsg);
  } else {
    setErrorMessage(errors[0].Message);
  }
  console.log(errors);
};

// Logout Action
var logout_options= {};

logout_options.onSuccess = function(response) {
  // On Success
  //Write your custom code here
  console.log("Session not found");
  window.location='/account/logout';
};

var forgotpassword_options = {};

forgotpassword_options.onSuccess = function(response) {
  document.getElementsByName("loginradius-forgotpassword")[0].reset();
  if (siteLocale === 'fr-CA') {
    setMessage("Password reset information sent to your provided email id, check email for further instructions");
  } else {
    setMessage("Password reset information sent to your provided email id, check email for further instructions");
  }
};

forgotpassword_options.onError = function(errors) {
  console.log(errors);
  var warningMsg = errors[0].Message;
  if (warningMsg.includes('field is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Ce champ est obligatoire.';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Invalid user ID and/or password') && siteLocale === 'fr-CA') {
    warningMsg = 'Identifiant ou mot de passe invalide';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Valid email ID is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Un idendifiant email valide est requis';
    setErrorMessage(warningMsg);
  } else {
    setErrorMessage(errors[0].Message);
  }
}

var verifyemail_options = {};
verifyemail_options.onSuccess = function(response) {
  $("#lr-social-traditional-login").hide();
  $("#interfacecontainerdiv").hide();
  $("#no-email-container").show();
  $("#no-email-container h4").hide();

  setMessage("Email verified, now you can login");
};

verifyemail_options.onError = function(errors) {
  $("#lr-social-traditional-login").hide();
  $("#interfacecontainerdiv").hide();
  $("#redirectologin").show();
  console.log(errors);
  setErrorMessage(errors[0].Message);
}

var resetpassword_options = {};

resetpassword_options.onSuccess = function(response) {
  document.getElementsByName("loginradius-resetpassword")[0].reset();

  setMessage("Password reset successfully, now you can login");
  $("#lr-raas-login").show();
  $("#login-container").show();
  $("#lr-social-traditional-login").show();
  $("#resetpassword-container").hide();

  // GA event
  let details = {
    hitType: 'event',
    eventCategory: "Reset password",
    eventAction: "Successful",
    eventLabel: "GTM-K32Q5NR"
  };
  ga('send', details)
};

resetpassword_options.onError = function(errors) {
  console.log(errors);
  if (warningMsg.includes('field is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Ce champ est obligatoire.';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Invalid user ID and/or password') && siteLocale === 'fr-CA') {
    warningMsg = 'Identifiant ou mot de passe invalide';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Valid email ID is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Un idendifiant email valide est requis';
    setErrorMessage(warningMsg);
  } else {
    setErrorMessage(errors[0].Message);
  }
}

var registration_options = {}
registration_options.onSuccess = function(response) {
  document.getElementsByName("loginradius-registration")[0].reset();

  setMessage("Email for verification has been sent to your provided email, please check email for further instructions");
};

registration_options.onError = function(errors) {
  console.log(errors);
  if (warningMsg.includes('field is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Ce champ est obligatoire.';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Invalid user ID and/or password') && siteLocale === 'fr-CA') {
    warningMsg = 'Identifiant ou mot de passe invalide';
    setErrorMessage(warningMsg);
  } else if (warningMsg.includes('Valid email ID is required') && siteLocale === 'fr-CA') {
    warningMsg = 'Un idendifiant email valide est requis';
    setErrorMessage(warningMsg);
  } else {
    setErrorMessage(errors[0].Message);
  }
};

var sl_options = {};
sl_options.onSuccess = function(response) {
  //Here you get the access token
  if (response.IsPosted) {
    document.getElementsByName("loginradius-socialRegistration")[0].reset();
    setMessage("Email for verification has been sent to your provided email, please check email for further instructions");
    jQuery('#interfacecontainerdiv').hide();
  } else {
    exchangeMultipassToken(response.access_token, function (data) {
      window.location = data.url;
    });
  }
};

sl_options.onError = function(errors) {
  console.log(errors);
  if (window.isSSORedirectedToken) {
    LRObject.init("logout", logout_options);
  } else {
    setErrorMessage(errors[0].Message);
  }
};

//Account Linking

var la_options = {};
la_options.container = "interfacecontainerdiv";
la_options.templateName = 'loginradiuscustom_tmpl_link';
la_options.onSuccess = function(response) {
  console.log(response);
};

la_options.onError = function(errors) {
  console.log(errors);
}

function lrLogout() {
  LRObject.init("logout", logout_options);

  if (getCookie('showLpTransferModal')) {
    eraseCookie('showLpTransferModal');
  }

  if (getCookie('showPrivacyModal')) {
    eraseCookie('showPrivacyModal');
  }
};

$( document ).ready(function() {
  if (window.location.pathname == "/logout/account") {
    LRObject.init("logout", logout_options);
  }
});

function eraseCookie(key) {
  var keyValue = getCookie(key);
  setCookie(key, keyValue, '-1');
}

function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}

function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function visibleLoadingSpinner(isvisible) {
  if (isvisible) {
    $("#loading-spinner").show().hide(10);
  } else {
    $("#loading-spinner").hide();
  }
};

LRObject.$hooks.register('beforeFormRender', function () {
  visibleLoadingSpinner(true);
});

LRObject.$hooks.register('afterFormRender', function () {
  visibleLoadingSpinner(false);
});
